import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import refPropType from 'utils/propTypes/ref';

import Icon from '../Icon';
import style from './ButtonStyledLikeLink.module.scss';

/**
 * Render a button for semantic purposes, but that has been designed to look
 * like an \<a\> (link). A purpose driven button variant.
 */
const ButtonStyledLikeLink = ({
  children,
  className,
  onClick,
  buttonRef,
  icon,
  disabled,
  ...otherProps
}) => (
  <button
    type="button"
    ref={buttonRef}
    onClick={onClick}
    className={classnames(style.button, className)}
    disabled={disabled}
    {...otherProps}
  >
    {!icon || <Icon type={icon} />}
    {children}
  </button>
);

ButtonStyledLikeLink.propTypes = {
  /**
   * Class name for the `button`
   */
  className: PropTypes.string,
  /**
   * Function to run `onClick`
   */
  onClick: PropTypes.func.isRequired,
  /**
   * contents of the button
   */
  children: PropTypes.node.isRequired,
  /**
   * Icon name
   */
  icon: PropTypes.string,
  /**
   * Disabled state
   */
  disabled: PropTypes.bool,
  /**
   * The ref to pass to the button element
   */
  buttonRef: refPropType,
};

ButtonStyledLikeLink.defaultProps = {
  className: null,
  icon: null,
  disabled: undefined,
  buttonRef: undefined,
};

ButtonStyledLikeLink.displayName = 'ButtonStyledLikeLink';

export default ButtonStyledLikeLink;
